// ============================================================================
// HEBREW TRANSLATIONS - UI (עברית)
// RTL Language - Right-to-Left
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'he',
    languageName: 'עברית',
    version: '1.0',
    direction: 'rtl'
  },
  
  app: {
    title: "UNITYQUEST דברי הימים\nשל האהבה",
    subtitle: "גילוי אינטראקטיבי של הכתובים",
    tagline: "ללכת לקראת האור האלוהי",
    menu: "תפריט",
    retry: "נסה שוב"
  },
  
  buttons: {
    play: "שחק",
    back: "חזור",
    continue: "המשך",
    restart: "התחל מחדש",
    close: "סגור",
    nextLevel: "שלב הבא",
    selectLevel: "בחירת שלב",
    retry: "נסה שוב",
    mainMenu: "תפריט ראשי",
    start: "התחל",
    cancel: "ביטול",
    confirm: "אישור",
    save: "שמור",
    load: "טען",
    yesRestart: "כן, התחל מחדש",
    noContinue: "לא, המשך",
    tryAgain: "נסה שוב",
    backToMenu: "חזור לתפריט"
  },
  
  labels: {
    score: "ניקוד",
    stars: "כוכבים",
    wisdom: "חכמה",
    revelation: "התגלות",
    lives: "חיים",
    combo: "קומבו",
    level: "שלב",
    easy: "קל",
    medium: "בינוני",
    hard: "קשה",
    correct: "נכון!",
    gameOver: "המבחן נכשל",
    victory: "ניצחון!",
    completed: "הושלם",
    rank: "דרגה רוחנית",
    points: "נקודות חכמה",
    unlockedLevels: "שלבים שנפתחו",
    questionOfKnowledge: "שאלת ידע",
    hintOfWisdom: "רמז חכמה",
    knowledgeMastered: "ידע נרכש!",
    knowledgeAcquired: "ידע הושג!",
    testFailed: "המבחן נכשל",
    wisdomBonus: "בונוס",
    xpGained: "ניסיון",
    newRank: "דרגה חדשה",
    nextGrade: "הדרגה הבאה",
    maxLevelReached: "הגעת לרמה המקסימלית!",
    wrongAnswer: "תשובה שגויה!"
  },
  
  menu: {
    playButton: "שחק",
    info: "מידע",
    treasures: "אוצרות",
    john: "יוחנן",
    reset: "איפוס",
    resetConfirm: "להתחיל את ההרפתקה מחדש?",
    resetWarning: "האם אתה בטוח שברצונך למחוק את כל ההתקדמות שלך?",
    resetLose: "תאבד:",
    wisdomPoints: "נקודות חכמה",
    starsCollected: "כוכבים שנאספו",
    levelsUnlocked: "שלבים שנפתחו",
    spiritualRank: "דרגה רוחנית",
    yesRestart: "כן, התחל מחדש",
    noContinue: "לא, המשך",
    newAdventure: "הרפתקה חדשה",
    readyToStart: "מוכן להתחיל?",
    startJourney: "התחל את המסע שלך בידע הכתובים!",
    audioControls: "בקרות שמע",
    mute: "השתק",
    unmute: "הפעל שמע",
    close: "סגור",
    language: "שפה",
    restartGame: "הפעל מחדש את המשחק"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "הרפתקה תנ״כית אינטראקטיבית",
    anonymousMode: "שחק אנונימי",
    anonymousDesc: "בחר כינוי",
    emailMode: "התחברות באימייל",
    emailDesc: "שמירה רב-מכשירית",
    pseudo: "כינוי",
    pseudoPlaceholder: "הכינוי שלך...",
    email: "כתובת אימייל",
    emailPlaceholder: "your@email.com",
    startPlaying: "התחל לשחק",
    sendLink: "שלח קישור",
    sending: "שולח...",
    connecting: "מתחבר...",
    back: "חזור",
    localSave: "ההתקדמות שלך תישמר מקומית",
    cloudSync: "אין צורך בסיסמה • סנכרון ענן",
    magicLink: "קבל קישור קסם באימייל",
    checkEmail: "✉️ בדוק את האימייל שלך! קישור התחברות נשלח.",
    checkSpam: "בדוק גם את תיקיית הספאם",
    waitingConnection: "ממתין לחיבור...",
    errorSend: "שגיאה בשליחת הקישור",
    rateLimited: "⏳ אנא המתן 15 שניות לפני שליחה מחדש של אימייל",
    importSession: "🔄 ייבוא סשן מהפרודקשן",
    errorConnection: "שגיאת חיבור",
    enterPseudo: "אנא הזן כינוי",
    enterEmail: "אנא הזן אימייל תקף",
    // Tooltips
    never: "אף פעם",
    save: "שמור משחק",
    lastSave: "אחרון",
    refresh: "טען מחדש התקדמות",
    logout: "התנתק",
    connectToCloud: "התחבר לשמירה מקוונת",
    editPseudo: "ערוך שם משתמש",
    confirm: "אשר",
    cancel: "ביטול",
    close: "סגור",
    passwordMode: "התחברות פשוטה",
    passwordDesc: "אימייל + סיסמה",
    password: "סיסמה",
    passwordPlaceholder: "לפחות 6 תווים",
    passwordMinLength: "לפחות 6 תווים",
    playWithoutAccount: "שחק ללא חשבון",
    forgotPassword: "שכחת סיסמה?",
    resetPasswordTitle: "איפוס סיסמה",
    resetPasswordSubtitle: "הזן את האימייל שלך כדי לקבל קישור לאיפוס",
    sendResetLink: "שלח קישור",
    resetEmailSent: "📧 נשלח מייל איפוס! בדוק את תיבת הדואר שלך.",
    errorReset: "שגיאה בשליחת המייל",
    backToSignin: "חזרה להתחברות",
    newPassword: "סיסמה חדשה",
    enterNewPassword: "בחר סיסמה חדשה מאובטחת",
    confirmPassword: "אשר סיסמה",
    updatePassword: "עדכן סיסמה",
    passwordsDontMatch: "הסיסמאות אינן תואמות",
    passwordUpdateSuccess: "✅ הסיסמה עודכנה בהצלחה!",
    errorUpdatePassword: "שגיאה בעדכון הסיסמה",
    resetLinkExpired: "קישור האיפוס פג תוקף או לא תקף",
    forgotPassword: "שכחת סיסמה?",
    signup: "הרשמה",
    signin: "התחברות",
    createAccount: "צור חשבון",
    signupInfo: "מלא את הטופס למטה",
    passwordInfo: "גישה מהירה עם סיסמה",
    signupButton: "צור את החשבון שלי",
    signinButton: "התחבר",
    passwordTooShort: "הסיסמה חייבת להכיל לפחות 6 תווים",
    emailAlreadyExists: "אימייל זה כבר בשימוש",
    emailExistsHint: "✉️ אימייל זה כבר רשום. נסה להתחבר! (אולי נוצר ממשחק אחר?)",
    switchToSignin: "🔑 עבור למצב התחברות עם האימייל הקיים שלך",
    invalidCredentials: "אימייל או סיסמה לא חוקיים",
    signupSuccess: "📧 חשבון נוצר! בדוק את האימייל שלך לאישור ההרשמה.",
    emailConfirmationRequired: "בדוק את תיבת הדואר הנכנס שלך כדי להפעיל את החשבון",
    checkSpamFolder: "זכור לבדוק את תיקיית הספאם שלך",
    connectionSuccess: "✅ התחברות הצליחה!",
    errorSignup: "שגיאה בהרשמה"},
  
  install: {
    title: "התקן את האפליקציה",
    subtitle: "גישה מהירה ולא מקוון",
    feature1: "הפעלה מיידית ממסך הבית",
    feature2: "עובד במצב לא מקוון לאחר ההתקנה",
    feature3: "חוויית אפליקציה מקורית",
    feature4: "אין צורך בהורדה מחנות",
    install: "התקן",
    dismiss: "מאוחר יותר",
    info: "תוכל להסיר את האפליקציה בכל עת"
  },
  
  ranks: {
    seeker: "מחפש",
    believer: "המתעורר",
    disciple: "תלמיד",
    servant: "משרת",
    witness: "עד",
    guardian: "שומר",
    wise: "חכם",
    prophet: "נביא",
    apostle: "שליח",
    seekerDesc: "תחילת המסע הרוחני",
    believerDesc: "תודעה רוחנית מתעוררת",
    discipleDesc: "לימוד התורות",
    servantDesc: "שירות ומסירות",
    witnessDesc: "שיתוף האמונה",
    guardianDesc: "הגנה על האמת",
    wiseDesc: "חוכמה וידע",
    prophetDesc: "חזון רוחני",
    apostleDesc: "מורה רוחני"
  },

  spiritualJourney: {
    beginning: "תחילת המסע הרוחני",
    progress: "התקדמות רוחנית",
    grade: "דרגה",
    xp: "נק' ניסיון",
    level: "רמה",
    nextGrade: "דרגה הבאה",
    still: "עוד",
    maxLevelReached: "הושגה הרמה המקסימלית!",
    masteredAllTeachings: "שלטת בכל התורות",
    progression: "התקדמות"
  },
  
  treasures: {
    title: "💎 אוצרות התנ״ך",
    verse: "פסוק היום",
    fact: "ידעת?",
    treasure: "אוצר נסתר",
    question: "שאלה מצחיקה",
    context: "הקשר",
    strongReference: "הפניה מקראית ללימוד מעמיק",
    verseOfDay: "✨ פסוק היום",
    didYouKnow: "🌟 ידעת?",
    hiddenTreasure: "📜 אוצר נסתר",
    funnyQuestion: "🤔 שאלה מצחיקה",
    emmanuelMemo: "תזכיר של עמנואל",
    emmanuelMessage: "הגעת לפסגת ההר, והידע נרכש. אבל אמונה איתנה דורשת ניסיון חיים, רחמים ואהבה אמיתית לישוע. ניסיונות החיים השונים יבחנו את דרכך, הדרך האמיתית שאנו בוחרים, את לבנו. אנחנו נשארים לא מושלמים, הרצונות שלנו רבים, ואהבת הרווח או הנוחות האישית שלנו הופכת לעתים קרובות מדי לעדיפות האנוכית שלנו. בקש מאלוהים חוכמה, אהבתו, כוחו, והכר בענווה בחולשותיך, כי שום דבר לא יכול להיות מוסתר ממנו... שום דבר. אין צורך לנסוע במצב פרטי, להשתמש ב-VPN או אפילו למחוק היסטוריה. צום כמו דניאל: מנע מעצמך לרגע את מה שאתה אוהב הכי הרבה, בשקט ובחוכמה. זה יאפשר לך לשמוע את אלוהים טוב יותר, לקבל נטייה לבבית מוכנה לשינויים עמוקים - ולעתים קרובות כואבים. אז חלומות וחזיונות יהפכו ברורים יותר, כמו יוסף. אבל היזהר מגאווה: אל תיכנע ל'אני תמיד צודק' או 'אני יודע יותר טוב'. כי התגלות האלוהים היא חסד יוצא דופן. אל תהפוך למורה של התורה, המסוגל לצלוב את ישוע שוב היום, הוא שפשוט מבקש לאהוב את הזולת... ולהעניק להם את אותה חופש שאתה מקבל. להחזיק באמונה פירושו להיכנס למערכת יחסים חופשית ולמסע הלב. זה יהפוך אותך לגיבורים חזקים, המסוגלים לבלתי אפשרי. כי החוויה של העל-טבעי, נוכחות האלוהים, אישורו או ברכתו יהפכו אותך לאיתן באמת.",
    jesusIsNot: "❌ הבהרה חשובה",
    clarification: "הבהרה חשובה",
    bibleOffline: "קרא תנ״ך ללא חיבור",
    bibleStudy: "לימוד תנ״כי",
    version: "גרסה",
    openReader: "פתח קורא",
    features: "תכונות"
  },
  
  messages: {
    chooseCard: "⚡ בחר את כרטיס הכוח שלך",
    cardHelp: "הוא ילווה אותך ב-3 השאלות של שלב זה",
    chooseAnswer: "📖 בחר את התשובה שלך:",
    wrongAnswer: "❌ תשובה שגויה! נותרו לך {lives} חיים. נסה שוב!",
    levelCompleted: "שלב {level} הושלם",
    questionsProgress: "שאלה {current} מתוך 3",
    starsCollected: "כוכבים שנאספו: {current}/{total}",
    pointsEarned: "+{points} נקודות חכמה",
    defeatedQuote: "הכל אוכל במשיח המחזק אותי",
    chapter: "פרק",
    chapterStars: "כוכבי הפרק",
    totalGlobal: "סך הכל",
    backToMenu: "חזרה לתפריט"
  },
  
  quotes: {
    wisdom: "ראשית חכמה יראת ה׳",
    faith: "הכל אוכל במשיח המחזק אותי",
    hope: "ה׳ רועי לא אחסר",
    love: "כי כה אהב אלוהים את העולם...",
    perseverance: "האמונה דורשת התמדה",
    defeat: "הכישלון מזמין לצמוח בידע"
  },

  cards: {
    faith: "אמונה",
    courage: "אומץ",
    wisdom: "חוכמה",
    faithKnowledge: "+50% נקודות",
    courageKnowledge: "הזדמנות שנייה",
    wisdomKnowledge: "רמז + בונוס",
    faithDesc: "מקסימום נקודות חוכמה שהושגו",
    courageDesc: "נקודות רגילות אבל הזדמנות שנייה",
    wisdomDesc: "רמז נחשף ו-25% נקודות+",
    chooseCard: "✨ בחר את כרטיס הידע שלך",
    cardEffects: "✨ השפעות כרטיסי הידע:",
    faithEffect: "+50% נקודות חוכמה - תגמול מקסימלי",
    courageEffect: "נקודות רגילות אבל הזדמנות שנייה בטעות",
    wisdomEffect: "+25% נקודות + רמז נחשף לכל שאלה",
    chooseWisely: "בחר בחוכמה, כי בחירתך תלווה אותך לאורך כל השלב"
  },

  challenge: {
    loading: "טוען שלב...",
    peace: "🕊️ השלום ישכון בביתך",
    questionsAwaiting: "🎯 3 שאלות ידע ממתינות לך",
    starsQuote: "כל כוכב הוא צעד אל האור האלוהי"
  },

  chapters: {
    "1": "בראשית",
    "2": "שמות",
    "3": "ישוע המשיח",
    "4": "צליבה/תחייה",
    "5": "הקהילה הראשונה",
    "6": "משלחות פאולוס",
    "7": "מכתבים/התגלות",
    "8": "שלב בונוס"
  },

  bible: {
    readerTitle: "📖 קורא התנ״ך",
    loading: "טוען כתבים...",
    menu: "תפריט",
    strong: "Strong",
    strongReferences: "הפניות Strong",
    verses: "פסוקים",
    previous: "קודם",
    next: "הבא",
    strongDefinition: "הפניה Strong",
    word: "מילה מקורית",
    transliteration: "תעתיק",
    pronunciation: "הגייה",
    meaning: "משמעות",
    definition: "הגדרה מלאה",
    usage: "שימוש תנ״כי",
    etymology: "אטימולוגיה",
    close: "סגור",
    moreReferences: "ו-{{count}} הפניות נוספות",
    copyright: "📖 Delitzsch Hebrew Gospels - נחלת הכלל • מספרי Strong כלולים"
  },

  philosophy: {
    title: "ממד פילוסופי",
    loveOntology: "אהבה כעיקרון אונטולוגי",
    loveDescription: "ישוע הופך את האהבה לבסיס מטאפיזי: לאהוב את אלוהים ואת הזולת הופך למבנה עצמו של הווייה אותנטית. האהבה חורגת ממוסר כדי להפוך לאופן קיום.",
    newCommandment: "המצווה החדשה",
    jesusEmphasizes: "כאשר ישוע נותן מצווה חדשה, הוא מדגיש את הפועל לאהוב",
    loveGod: "אהבת את אלוהיך בכל לבבך",
    loveNeighbor: "ואהבת לרעך כמוך",
    lovePriority: "האהבה הופכת לעדיפות"
  },

  footer: {
    version: "גרסה 1.0 • 2024",
    dedication: "פותח לכבוד אלוהים"
  },

  endCredits: {
    lines: [
      { text: "הגעת לפסגת ההר", delay: 2000 },
      { text: "למדת דברים רבים", delay: 2000 },
      { text: "אמונתך גדלה בכל יום", delay: 2000 },
      { text: "אתה חווה דברים יפים עם אלוהים", delay: 2000 },
      { text: "הקשיים עוזרים לך לצמוח", delay: 2000 },
      { text: "הם מראים מה חשוב", delay: 2000 },
      { text: "היה צנוע כמו ילד קטן", delay: 2000 },
      { text: "אלוהים אוהב את לבך הפשוט", delay: 2000 },
      { text: "בשקט אתה שומע את אלוהים", delay: 2000 },
      { text: "הצום משחרר את רוחך", delay: 2000 },
      { text: "התפלל ואלוהים ינחה אותך", delay: 2000 },
      { text: "גאווה מסתירה את האמת", delay: 2000 },
      { text: "חסד אלוהים נהדר", delay: 2000 },
      { text: "הוא בא מלב אלוהים", delay: 2000 },
      { text: "אמונה אמיתית משחררת אותך", delay: 2000 },
      { text: "היא מאחדת אותך עם אלוהים לנצח", delay: 2000 },
      { text: "אהבה יכולה לשנות הכל", delay: 2000 },
      { text: "היא יכולה לעשות ניסים", delay: 2000 },
      { text: "חזור אחרי", delay: 2000 },
      { text: "ישוע, אני נותן לך את לבי", delay: 3000 },
      { text: "אתה המלך שלי, המושיע שלי", delay: 3000 },
      { text: "בוא ושנה את חיי", delay: 3000 },
      { text: "המסע ממשיך עכשיו", delay: 2000 },
      { text: "שתף את האור היפה הזה", delay: 2000 },
      { text: "אל החיים שלעולם לא נגמרים", delay: 2000 },
      { text: "שמור את האהבה בלבך", delay: 3000 },
      { text: "כמו אוצר יקר", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "!מזל טוב",
      proud: "אנחנו גאים בך",
      courage: "לוחם אמיץ",
      peace: "נושא שלום",
      child: "ילד של אלוהים",
      blessing: "שאלוהים יברך אותך",
      continue: "המשך"
    }
  },

  mountain: {
    spiritualAscension: "עלייה רוחנית",
    levelProgress: "רמה {{level}} • {{stars}} כוכבים הושגו",
    combo: "קומבו",
    perfectMessage: '"כי מחשבותי אינן מחשבותיכם" - הכבש מטפס לעבר החכמה המושלמת',
    goodMessage: '"בקשו ותמצאו" - העלייה לעבר האמת נמשכת',
    startMessage: '"אמונה, גם קטנה כגרגר חרדל" - צעד ראשון לעבר האור',
    skipAnimation: "דלג על אנימציה",
    chapter: "פרק",
    chapterProgress: "פרק {{current}}/{{total}}",
    secret: "סוד",
    waypoints: {
      start: "התחלה",
      firstSlope: "המדרון הראשון",
      lastSlope: "המדרון האחרון"
    },
    status: {
      defeat: "תבוסה",
      inProgress: "בתהליך",
      victory: "ניצחון"
    }
  },

  validation: {
    pseudoTooShort: "שם המשתמש חייב להכיל לפחות 2 תווים",
    enterPseudo: "אנא הזן שם משתמש"
  },

  pseudoSetup: {
    title: "בחר את שם המשתמש שלך",
    confirm: "אישור שם"
  },

  navigation: {
    back: "חזור"
  },

  console: {
    starsUnlocked: "כוכבים הושגו! פתיחת פרק",
    defeatAnimation: "תבוסה... המשיח יורד"
  },

  errors: {
    progressionError: "שגיאת התקדמות",
    invalidProgressionData: "נתוני התקדמות לא חוקיים:"
  },

  levels: {
    chaptersAndBonus: "8 פרקים + שלב בונוס",
    bonusUnlocked: "🏆 שלב הבונוס נפתח! הגעת לשלמות רוחנית!",
    starsToDiscover: "273 {stars} לגלות",
    starsPerLevel: "3 {stars} לכל שלב"
  },

  architecture: {
    title: "🔧 ארכיטקטורה טכנית",
    react: {
      name: "React",
      description: "ממשק מודרני"
    },
    modules: {
      name: "מודולים",
      description: "טעינה דינמית"
    },
    localStorage: {
      name: "אחסון מקומי",
      description: "אחסון מקומי"
    },
    tailwind: {
      name: "Tailwind",
      description: "עיצוב רספונסיבי"
    }
  },

  gameManager: {
    title: "שמירת משחק",
    saveLocal: "שמירה מקומית",
    saveCloud: "ענן מסונכרן",
    saveWaiting: "ממתין לחיבור",
    lastSave: "שמירה אחרונה:",
    never: "אף פעם",
    saving: "שומר...",
    save: "שמור",
    loadProgress: "טען",
    loading: "טוען...",
    autoSaveEnabled: "💾 שמירה אוטומטית מופעלת",
    saveError: "❌ שגיאת שמירה",
    gameSaved: "✅ המשחק נשמר!",
    gameLoaded: "📥 המשחק נטען!"
  },

  info: {
    title: "משחק האמונה",
    subtitle: "מסע רוחני דרך הכתבים",
    yourStats: "הסטטיסטיקות שלך",
    score: "ציון",
    wisdom: "חוכמה",
    revelation: "התגלות",
    createdWith: "נוצר עם",
    creator: "עמנואל",
    developerPassionate: "מפתח נלהב ומאמין שמרצה את לבו בעבודה זו.",
    artistModule: "עמנואל אמן",
    features: "תכונות",
    multipleChapters: "📖 פרקים ורמות מרובות",
    powerCards: "🎴 כרטיסי כוח אסטרטגיים",
    progressionSystem: "⭐ מערכת התקדמות מתגמלת",
    bibleTreasures: "💎 אוצרות תנ\"כיים לגילוי",
    howToPlay: "איך לשחק",
    selectLevel: "בחר רמה או פרק",
    choosePowerCard: "בחר כרטיס כוח",
    answerQuestions: "ענה על השאלות",
    earnStars: "הרווח כוכבים והתקדם",
    tips: "עצות",
    readCarefully: "קרא כל שאלה בקפידה",
    useWisdomCard: "השתמש בכרטיס החוכמה לרמזים",
    courageGivesSecondChance: "האומץ נותן לך הזדמנות שנייה",
    faithMaximizes: "האמונה ממקסמת את הכוכבים שלך",
    johnGospelTitle: "בשורת יוחנן",
    johnGospelStats: "21 פרקים • 878 פסוקים • 14 שפות",
    bibleReaderStrong: "קורא תנ\"ך + Strong",
    bibleReaderStrongDesc: "קריאה מלאה עם מילון Strong",
    johnTreasures: "אוצרות יוחנן",
    johnTreasuresDesc: "אוצרות תנ\"כיים ועובדות מעניינות",
    quickAccessChapters: "גישה מהירה לפרקים מפורסמים:",
    johnChapter1: "פרולוג",
    johnChapter3: "להיוולד מחדש",
    johnChapter14: "אני הדרך",
    johnChapter20: "תחיית המתים",
    version: "גרסה",
    madeWithLove: "נעשה באהבה ובאמונה",
    backToMenu: "חזרה לתפריט"
  },

  bible: {
    readerTitle: "קורא תנ\"ך",
    johnReaderTitle: "קורא הבשורה של יוחנן",
    john: "יוחנן",
    loading: "טוען...",
    loadingChapter: "פרק {chapter} של בשורת יוחנן. נתונים מלאים נטענים...",
    exploreWhileLoading: "בינתיים, אתה יכול לחקור פרקים אחרים או להשתמש בפונקציית החיפוש.",
    menu: "תפריט",
    tabBible: "תנ\"ך",
    tabUnity: "אחדות",
    strong: "Strong",
    strongReferences: "הפניות Strong",
    verses: "פסוקים",
    previous: "הקודם",
    next: "הבא",
    strongDefinition: "הגדרת Strong",
    word: "מילה",
    transliteration: "תעתיק",
    close: "סגור",
    share: "שתף",
    shareVerse: "שתף פסוק",
    shareSelection: "שתף בחירה",
    pronunciation: "הגייה",
    meaning: "משמעות",
    definition: "הגדרה",
    usage: "שימוש",
    etymology: "אטימולוגיה",
    search: "חיפוש",
    definitionNotFound: "ההגדרה לא נמצאה",
    definitionLoading: "טוען הגדרה...",
    imageFeatureComing: "תכונת תמונה בקרוב!",
    copyError: "שגיאת העתקה",
    error: "שגיאה",
    errorLoading: "שגיאה בטעינת הנתונים",
    retry: "נסה שוב",
    readerInDevelopment: "הקורא בפיתוח...",
    verseCopied: "הפסוק הועתק!",
    moreReferences: "הפניות נוספות",
    copyright: "© זכויות יוצרים",
    markAsRead: "הקטע נקרא",
    alreadyRead: "כבר נקרא",
    readingBonus: "בונוס קריאה",
    results: "תוצאות",
    result: "תוצאה",
    copy: "העתק",
    image: "תמונה"
  },

  mountain: {
    chapter: "פרק",
    secret: "סוד",
    spiritualAscension: "עלייה רוחנית",
    levelProgress: "התקדמות הרמה",
    combo: "קומבו",
    perfectMessage: "מושלם! 🌟",
    goodMessage: "טוב מאוד! ⭐",
    startMessage: "התחל! 🎯",
    skipAnimation: "דלג על האנימציה",
    stats: {
      points: "נקודות",
      level: "רמה"
    },
    waypoints: {
      start: "התחלה",
      firstSlope: "מדרון ראשון",
      lastSlope: "מדרון אחרון"
    },
    status: {
      victory: "ניצחון",
      defeat: "תבוסה",
      inProgress: "בתהליך"
    }
  },

  bibleResources: {
    inAppReader: {
      name: "קורא בתוך האפליקציה",
      description: "קורא תנ\"ך משולב עם תכונות מתקדמות",
      features: {
        offline: "✅ עבודה במצב לא מקוון",
        strong: "✅ הגדרות Strong משולבות",
        navigation: "✅ ניווט קל בין פרקים"
      }
    }
  },

  quotes: {
    wisdom: "החוכמה מתחילה ביראת ה'",
    faith: "האמונה היא הביטחון במה שמקווים לו",
    hope: "התקווה היא העוגן של הנשמה",
    love: "האהבה היא הגדולה מכולן",
    perseverance: "ההתמדה מייצרת אופי",
    defeat: "אל תוותר, כי כל נפילה היא הזדמנות לקום חזק יותר"
  },

  philosophy: {
    title: "פילוסופיה",
    loveOntology: "אונטולוגיית האהבה",
    loveDescription: "בליבת האמונה המשיחית, האהבה היא לא רק ערך מוסרי – היא המהות של אלוהים עצמו.",
    newCommandment: "מצווה חדשה אני נותן לכם: אהבו זה את זה. כמו שאהבתי אתכם, גם אתם אהבו זה את זה.",
    jesusEmphasizes: "ישוע מדגיש שני היבטים של אהבה:",
    loveGod: "אהבת אלוהים באופן אינטימי",
    loveNeighbor: "אהבת הזולת כמוך",
    lovePriority: "אהבה זו היא העדיפות המוחלטת, שעומדת מעל כל דבר אחר."
  },

  unity: unityTranslations,

  footer: {
    version: "גרסה 1.0",
    dedication: "מוקדש לכל מי שמחפש אמת ושלום"
  },

  endCredits: {
    lines: [
      { text: "🌟 הגעת לסוף המסע 🌟", delay: 0 },
      { text: "", delay: 2000 },
      { text: "משחק האמונה", delay: 3000 },
      { text: "מסע רוחני דרך הכתבים", delay: 4500 },
      { text: "", delay: 6000 },
      { text: "✨ נוצר עם ✨", delay: 7000 },
      { text: "❤️ אהבה", delay: 8500 },
      { text: "🙏 אמונה", delay: 10000 },
      { text: "💫 תקווה", delay: 11500 },
      { text: "", delay: 13000 },
      { text: "👨‍💻 פיתוח", delay: 14000 },
      { text: "עמנואל", delay: 15500 },
      { text: "מפתח נלהב ומאמין", delay: 17000 },
      { text: "", delay: 18500 },
      { text: "🎨 עיצוב", delay: 19500 },
      { text: "React + Tailwind CSS", delay: 21000 },
      { text: "", delay: 22500 },
      { text: "📖 תוכן", delay: 23500 },
      { text: "מבוסס על הכתבים הקדושים", delay: 25000 },
      { text: "", delay: 26500 },
      { text: "🙏 תודה מיוחדת", delay: 27500 },
      { text: "לכל מי ששיתף במסע הזה", delay: 29000 },
      { text: "", delay: 30500 },
      { text: "💝 מוקדש", delay: 31500 },
      { text: "לכל מי שמחפש אמת", delay: 33000 },
      { text: "ושלום בחייו", delay: 34500 },
      { text: "", delay: 36000 },
      { text: "✨ תודה שהשתתפת ✨", delay: 37000 },
      { text: "🌟 ברכות על כל צעד 🌟", delay: 39000 }
    ],
    finalMessages: {
      congratulations: "כל הכבוד לסיום המסע!",
      proud: "אתה יכול להיות גאה בהתקדמות שלך.",
      courage: "האומץ שלך הוביל אותך עד כאן.",
      peace: "שהשלום ילווה את צעדיך.",
      child: "אתה ילד יקר של אלוהים.",
      blessing: "הברכה שלי איתך.",
      continue: "המסע נמשך..."
    }
  },

  validation: {
    pseudoTooShort: "הכינוי חייב להיות באורך של לפחות 3 תווים",
    enterPseudo: "אנא הכנס כינוי"
  },

  pseudoSetup: {
    title: "הגדרת פרופיל",
    profileConfig: "הגדרת הפרופיל שלך",
    connectedWith: "מחובר עם:",
    playerPseudo: "הכינוי שלך בשחקן",
    pseudoPlaceholder: "בחר כינוי (3+ תווים)",
    pseudoRequirements: "הכינוי שלך יהיה גלוי במשחק",
    suggestions: "💡 המלצה: בחר שם שיזכיר אותך ואת ערכיך",
    confirm: "אשר",
    errorConfig: "שגיאה בהגדרת הפרופיל"
  },

  navigation: {
    back: "חזור"
  },

  console: {
    starsUnlocked: "כוכבים נפתחו:",
    defeatAnimation: "אנימציית תבוסה מושלמת"
  },

  errors: {
    progressionError: "שגיאה בטעינת ההתקדמות",
    invalidProgressionData: "נתוני התקדמות לא תקינים"
  },

  levels: {
    chaptersAndBonus: "פרקים ובונוסים",
    bonusUnlocked: "בונוס נפתח!",
    starsToDiscover: "כוכבים לגילוי",
    starsPerLevel: "כוכבים לרמה"
  },

  architecture: {
    title: "ארכיטקטורה",
    react: {
      name: "React",
      description: "ספריית UI מודרנית לממשק אינטראקטיבי"
    },
    modules: {
      name: "מודולים ES6",
      description: "קוד מאורגן ומתוחזק"
    },
    localStorage: {
      name: "LocalStorage",
      description: "שמירת התקדמות מקומית"
    },
    tailwind: {
      name: "Tailwind CSS",
      description: "עיצוב מהיר ומותאם אישית"
    }
  },

  gameManager: {
    title: "ניהול המשחק",
    saveLocal: "שמור מקומי",
    saveCloud: "שמור בענן",
    saveWaiting: "שמירה ממתינה...",
    lastSave: "שמירה אחרונה:",
    never: "אף פעם",
    saving: "שומר...",
    save: "שמור",
    loadProgress: "טען",
    loading: "טוען...",
    autoSaveEnabled: "💾 שמירה אוטומטית מופעלת",
    saveError: "❌ שגיאת שמירה",
    gameSaved: "✅ המשחק נשמר!",
    gameLoaded: "📥 המשחק נטען!"
  }
};

export default uiTranslations;
